import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const IsNotAny = ({ property, onChange, value }) => {

  const PropertyComponent = resolveComponentForOperator(property.type, 'IS_NOT_ANY')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        value={value}
        isOperator={true}
      />
    </div>
  )
}

export default IsNotAny
